import React from "react";
import { email, maxLength, BooleanInput, Edit, SimpleForm, TextInput, useTranslate } from "react-admin";

import { HiddenInput } from "../components/hidden";
import { UndeletableToolbar } from "../components/UndeletableToolbar";
import { preventSendNull } from "../utils/api";

const validateEmail = [maxLength(254), email()];

export const WholesalerSettingMailNotificationEdit = (props: any) => {
  const translate = useTranslate();

  return (
    <Edit
      {...props}
      resource="wholesaler_setting_mail_notification"
      title={translate("resources.wholesaler_setting_mail_notification.name")}
      redirect="/wholesalers/me/setting_mail_notification"
    >
      <SimpleForm mode="onTouched" toolbar={<UndeletableToolbar />}>
        <h2>{translate("resources.wholesaler_setting_mail_notification.name")}</h2>
        <BooleanInput source="when_added_pending_task" />
        <BooleanInput source="when_processed_deal" />
        <BooleanInput source="when_changed_profile" />
        <TextInput source="additional_email1" validate={validateEmail} parse={preventSendNull} fullWidth />
        <TextInput source="additional_email2" validate={validateEmail} parse={preventSendNull} fullWidth />
        <TextInput source="additional_email3" validate={validateEmail} parse={preventSendNull} fullWidth />
        <HiddenInput source="version_number" />
      </SimpleForm>
    </Edit>
  );
};
